import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import Countdown from '../../components/Countdown';

// Rounds
@inject('Game4Store')
@observer
export default class Game4Step4 extends Component {

    static defaultProps = {
        onChangeAnswer: () => {},
        onRevisedAnswer: () => {},
        onGoToNextQuestion: () => {}
    };

    constructor(props) {
        super(props);

        this.selected0 = false;
        this.selected1 = false;

        this.state = {
            showCorrectAnswer: false,
            isCorrect: false,
            showQuestion: false,
            player: this.props.Game4Store.getPlayerTurn(),
            question: this.props.Game4Store.getRandomQuestionByLevel(),
            answerSelected: -1,
        }
    }

    /**
     * Updates score with pontuation than teacher mark
     * @param player
     * @param index
     * @param e
     */
    addPointsToScore(player, index, e) {
        this.props.onRevisedAnswer(true);
        this.props.onChangeAnswer({player, index});

        const btns = document.querySelectorAll(".btn-answer");
        for (let bt of btns) {
            if (bt.name === "btn" + index) {
                if (bt.className == "btn-answer selected") {
                    bt.className = "btn-answer";
                    this.selected = false;
                    this.props.Game4Store.pause = false;
                    this.props.Game4Store.start = true;
                } else {
                    bt.className = "btn-answer selected";
                    this.selected = true;
                    this.props.Game4Store.pause = true;
                    this.props.Game4Store.start = false;
                }
            } else {
                bt.className = "btn-answer";
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.goToNextQuestion === true) {
            const btns = document.querySelectorAll(".btn-answer");
            for (let bt of btns) {
                bt.className = "btn-answer";
            }

            this.setState({
                showCorrectAnswer: false,
                isCorrect: false,
                showQuestion: false,
                player: this.props.Game4Store.getPlayerTurn(),
                question: this.props.Game4Store.getRandomQuestionByLevel(),
                answerSelected: -1
            });

            this.props.onGoToNextQuestion(false);
        }
    }

    /**
     * Show question when timer is finished
     */
    handleEndTimer = () => {
        this.setState({showQuestion: true});
    };

    handleSkipTimer = () => {
        this.setState({showQuestion: true});
    }

    /**
     * Mark an answer by student
     * @param answerSelected
     */
    handleClickAnswer = (answerSelected) => {
        this.setState({answerSelected});
    };

    /**
     * Check if student answer was correct
     */
    handleClickCheckItsCorrect = (player, index) => {

        this.setState((prevState) =>
            ({
                showCorrectAnswer: true,
                isCorrect: prevState.answerSelected.correct,
                showQuestion: true
            })
        );

        if( this.state.answerSelected.correct === false) {
            this.props.onRevisedAnswer(true);
        }
    };

    render() {

        const {
            Game4Store
        } = this.props;

        const {
            levelList
        } = Game4Store;

        const {
            question,
            player,
            answerSelected
        } = this.state;

        const levels = [...levelList, 'All Levels'];

        const answersEl = Game4Store.answers.map(
            (answer, index) => <button
                name={"btn" + index}
                className="btn-answer"
                key={index}
                onClick={this.addPointsToScore.bind(this, player, index)}>{answer.label}</button>
        );

        const round = Math.ceil(Game4Store.round / Game4Store.numberPlayers);

        /**
         * Show reponse correct or incorrect by status
         */
        const responses = question.responses.map((r, index) => (
            <div key={index} className={"alternatives-option"
            + (((r.correct && r === answerSelected && this.state.showCorrectAnswer)
                || (r.correct && r !== answerSelected && this.state.showCorrectAnswer))
                ? " correct" : "")
            + (!r.correct && r === answerSelected && this.state.showCorrectAnswer ? " incorrect" : "")
            + (answerSelected === r ? " selected" : "")}
                 onClick={() => this.handleClickAnswer(r)}>
                <span>{["a", "b", "c"][index]}</span> {r.label}
            </div>
        ));

        return (
            <div className="step-4">
                <ScoreBar players={Game4Store.players}/>
                <h1>Round {round}</h1>
                <div className={"team-name " + player.team.color}>{player.name}</div>
                {!(this.state.showQuestion || this.state.showCorrectAnswer) &&
                [
                <Countdown
                    onEndTimer={() => this.handleEndTimer()}
                    label="Start Timer"
                    labelRestart="loading..."
                    minutes={0}
                    seconds={20}/>,
                <p><strong className="level">{levels[question.level]}</strong></p>,<br/>,<div>
                    <button className="skip" onClick={() => this.handleSkipTimer()}>Skip</button>
                </div>]
                }
                <div>
                    <div className={"question " + (this.state.showQuestion ? "show" : "")}>
                        <div className="question-statement">
                            <p><strong className="level">{levels[question.level]}</strong> <br/>
                                <span dangerouslySetInnerHTML={{__html: question.statement}}/></p>
                            <div className="alternatives">
                                {responses}
                                {!this.state.showCorrectAnswer &&
                                <button className={ + this.state.answerSelected === -1 ? "disabled" : ""} onClick={() => this.handleClickCheckItsCorrect(player, 0)}>Check answer</button>
                                }
                            </div>
                            <div
                                className={"answers "
                                + (this.state.showCorrectAnswer && this.state.isCorrect ? "show" : "")}>
                                {answersEl}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
};

const ScoreBar = ({players = []}) => {

    const scores = players.map(
        (player, index) => (
            <Score key={index} player={player}/>
        )
    );

    return (
        <div className="ScoreBar">
            {scores}
        </div>
    )
};

const Score = ({player}) => {
    return (
        <div className="Score">
            <div className={"team-name " + player.team.color}>{player.name}</div>
            <div>{player.score} Points</div>
        </div>
    )
};


// WEBPACK FOOTER //
// ./src/containers/Game4/Game4Step4.js